import { render } from "./question-result-true-false-card.vue?vue&type=template&id=51ea4316&ts=true"
import script from "./question-result-true-false-card.vue?vue&type=script&lang=ts"
export * from "./question-result-true-false-card.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__